<template>
  <section class="our-work">
    <div class="container">
      <div class="row our-work__header"></div>
      <div class="row our-work__customers" v-if="data.customers">
        <template v-for="(customer, index) in data.customers">
          <div :class="get_customer_class(customer, index)" :key="index">
            <div
              v-if="customer.image.sizes"
              class="our-work__customers__customer__inner"
              @click="isClickable(customer) ? setActiveCustomer(index) : false"
            >
              <div class="our-work__customers__customer__image">
                <inline-svg
                  v-if="customer.image.url.indexOf('svg') >= 0"
                  :src="customer.image.url"
                />
                <img
                  v-else
                  :src="customer.image.sizes['medium']"
                  :title="customer.image.title"
                />
              </div>
            </div>
          </div>
          <OurWorkInfo
            v-if="index % 2 === 1"
            :key="`info_mobile_` + index"
            :customer="data.customers[active_customer_index]"
            :row_number="Math.floor(index / 2)"
            :index="index"
            :active_customer_index="active_customer_index"
            :is_mobile="true"
          />
          <OurWorkInfo
            v-if="index % 4 === 3 || index === data.customers.length - 1"
            :key="`info_` + index"
            :customer="data.customers[active_customer_index]"
            :row_number="Math.floor(index / 4)"
            :active_customer_index="active_customer_index"
            :is_mobile="false"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import OurWorkInfo from "./OurWorkInfo";

export default {
  name: "OurWork",
  components: { OurWorkInfo },
  data() {
    return {
      data: window.our_work_data,
      active_customer_index: null
    };
  },
  methods: {
    get_customer_class(customer, index) {
      let className = "col-6 col-md-3 our-work__customers__customer";
      if (this.isClickable(customer)) {
        className += " our-work__customers__customer--clickable";
      }
      if (this.active_customer_index === index) {
        className += " our-work__customers__customer--active";
      }
      return className;
    },
    setActiveCustomer(customer_index) {
      let timeoutVal = 0;
      if (this.active_customer_index) {
        this.active_customer_index = null;
        timeoutVal = 300;
      }
      setTimeout(() => {
        this.active_customer_index = customer_index;
      }, timeoutVal);
    },
    isClickable(customer) {
      return customer.has_quotes || customer.has_services_links;
    }
  }
};
</script>

<style scoped lang="scss">
.our-work {
  background-color: #f5f5f5;
  padding: 32px 0 13px;

  &__customers {
    position: relative;

    &__customer {
      padding-bottom: 32px;
      position: relative;

      &::after,
      &::before {
        opacity: 0;
        transition: bottom 0s ease-in-out 0s, opacity 0s ease-in-out 0s;
        content: "";
        width: 40px;
        height: 40px;
        position: absolute;
        bottom: 0px;
        left: calc(50% - 16px);
        background-color: white;
        transform: rotate(45deg);
        box-shadow: 0px 10px 16px 0px rgba(0, 0, 0, 0.1);
        z-index: 1;
      }

      &:after {
        z-index: 3;
        box-shadow: none;
      }

      &--clickable {
        .our-work__customers__customer__inner {
          background-color: white;
          cursor: pointer;
          position: relative;
          top: 0;
          transition: top 0.2s ease-in-out;

          &:after {
            top: 0;
            left: 0;
            content: "";
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 100%;
            box-shadow: 0px 10px 16px 0px rgba(0, 0, 0, 0.1);
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
          }

          &:hover,
          &:focus {
            top: -1px;

            &:after {
              opacity: 1;
            }
          }
        }
      }

      &--active {
        .our-work__customers__customer__inner {
          top: -1px;
          &:after {
            opacity: 1;
          }
        }

        &::after,
        &::before {
          opacity: 1;
          bottom: -20px;
          transition: bottom 0s ease 0.3s, opacity 0.2s ease-in-out 0.3s;
        }
      }

      &__inner {
        width: 100%;
        padding-top: 100%; /* 1:1 Aspect Ratio */
        position: relative; /* If you want text inside of it */
      }

      &__image {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        justify-content: space-around;

        svg,
        img {
          width: auto;
          max-width: 50%;
          height: auto;
          max-height: 100px;

          @media all and (-ms-high-contrast: none) {
            max-height: 100px;
            height: auto;
          }
        }
      }

      &--clickable {
      }
    }
  }
}
</style>
